module.exports = __webpack_public_path__ + "static/media/iconPenStepHorizontal.e29a9e8f.svg";